module.exports = __webpack_public_path__ + "img/rejected.4a2a72fc.svg";